import React from "react";
import { withLocalize, Translate } from "react-localize-redux";
import { getColor, red, yellow, green } from "../../common/colors";
import CustomTooltip from "../../common/customTooltip";
import BbPopover from '../../common/popover'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


const getRotation = (index, min, max, top = true) => {
    if (index > max) { return top ? "rotate(-90deg)" : "rotate(90deg)" };
    if (index < min) { return top ? "rotate(90deg)" : "rotate(-90deg)" };
    return ""
}

//pointers are based on mix max scale
//if greater than 100, return 95, so that pointer doesnt overflow the div
const getMargin = (value, min, max) => {
    let total = Math.abs(min) + Math.abs(max);
    let margin = (Math.abs(min) + value) / total * 100;
    return margin >= 100 ? 95 : margin < 0 ? 0 : margin;
}
//color breaks
const getGradientColor = (min, i0, i1, i2, max) => {
    let length = Math.abs(min) + max;
    let pct = (a, b, l) => { return (a === b) ? 0 : Math.abs((Math.abs(a) - Math.abs(b)) / l * 100) }

    let g = pct(min, i0, length);
    let gy = pct(i0, i1, length) + g;
    let yr = pct(i1, i2, length) + gy;
    let r = pct(i2, max, length) + yr;

    return `linear-gradient(to right,   ${green} ${g}%, 
                                        ${yellow} ${gy}%, 
                                        ${red} ${yr}%,
                                        ${red} ${r}%)`

}

class Gradient extends React.Component {
    state = {
        marginTopPointer: getMargin(this.props.index, this.props.min, this.props.max),
        marginBottomPointer: getMargin(this.props.avgIndex, this.props.min, this.props.max),
        rotationTop: getRotation(this.props.index, this.props.min, this.props.max),
        rotationBottom: getRotation(this.props.avgIndex, this.props.min, this.props.max, false)
    }
    render() {
        return (
            <React.Fragment>
                <div className="rating-card">
                    <span>
                        <BbPopover
                            title={this.props.translate("Repi.Report.ITradeIndex")}
                            placement='left'
                            content={this.props.translate(this.props.isRepi ? "Repi.Report.ITradeTooltip" : "Report.Ratings.ITradeTooltip")}
                            targetId="iTrade-Tooltip">
                            <span className="icon-gray print-hidden" id="iTrade-Tooltip" href="#"><FontAwesomeIcon icon="question-circle" /></span>
                        </BbPopover>
                    </span>
                    <div className="rating-header">
                        <span className="rating-header-body">
                            <span></span>
                            <span className='underlined-title-wrapper'>
                                <span className='underlined-title'>{this.props.translate("Repi.Report.ITradeIndex")}</span>
                            </span>
                            <span></span>
                        </span>
                    </div>
                    <div style={{ textAlign: "center", color: getColor(this.props.index, this.props.index0, this.props.index1, this.props.index2), fontSize: "2em" }}>{this.props.index}</div>
                    <div>
                        <span style={{ marginLeft: `${this.state.marginTopPointer}%`}}></span>
                        <CustomTooltip textAlign="right" placement='left' id="iTrade-top-tooltip" text={this.props.translate("Report.Ratings.iTradeTopArrowTooltip")} hideIcon>
                            <span className="itrade-pointer-top" id="iTrade-top-tooltip" style={{
                             color: getColor(this.props.index, this.props.index0, this.props.index1, this.props.index2),
                            transform: this.state.rotationTop,
                            marginBottom: "3px"
                            }}> &#9660;</span>
                        </CustomTooltip>
                    </div>

                    <div className="itrade-gradient" style={{ backgroundImage: getGradientColor(this.props.min, this.props.index0, this.props.index1, this.props.index2, this.props.max) }}></div>
                    <div>
                        <span style={{ marginLeft: `${this.state.marginBottomPointer}%` }}></span>
                        <CustomTooltip textAlign="right" placement='left' id="iTrade-bottom-tooltip" text={this.props.translate("Report.Ratings.iTradeBottomArrowTooltip")} hideIcon>
                            <span className="itrade-pointer-bottom" id="iTrade-bottom-tooltip" style={{
                            color: getColor(this.props.avgIndex, this.props.index0, this.props.index1, this.props.index2),
                            transform: this.state.rotationBottom,
                            marginTop: "5px"
                            }}> &#9650;</span>
                        </CustomTooltip>
                    </div>
                    <div className="itrade-gradient-root-desc">
                        <Translate id={this.props.isRepi ? "Repi.Report.ITradeIndexIndustry" : "Report.Itrade.AvgSectorTradeIndex"} />: <span style={{ color: getColor(this.props.avgIndex, this.props.index0, this.props.index1, this.props.index2) }}>{this.props.avgIndex}</span>
                    </div>
                </div>
            </React.Fragment >
        )
    }
}

export default withLocalize((Gradient))